import React from 'react';

function ModalContent({ children, gray }: { children: React.ReactNode; gray?: boolean }) {
  const classes = ['px-4', 'py-5', 'sm:p-6', 'text-gray-500', 'text-sm'];

  if (gray) {
    classes.push('bg-gray-50');
  }

  return <div className={classes.join(' ')}>{children}</div>;
}

export default ModalContent;
